<template>
  <!-- 优惠券类型：0:训练营抵扣券 1:私教坊抵扣券 2:满减券 -->
  <!-- （0：未使用 1：已使用 2：已作废 3：已过期） -->
  <div v-gxxt-loading="isLoadingMore">
    <ul class="l-coupons" v-if="couponList.records.length>0">
      <li
        class="c-item"
        :class="{invalid: item.status!=0,'full-discount':item.couponType == 2}"
        v-for="item in couponList.records"
        :key="item.id"
      >
        <div class="c-item__label" v-if="item.couponType == 0 ||item.couponType==1 ">
          全额
          <br />抵扣券
        </div>
        <div class="c-item__label" v-if="item.couponType == 2">
          {{item.shareDescription.split(',')[1]}}
          <span>{{item.shareDescription.split(',')[0]}}可用</span>
        </div>
        <div class="c-item__info">
          <div class="c-item__title">{{item.name}}</div>
          <div class="c-item__rule">{{item.discountContent}}</div>
          <div class="c-item__date">有效期至：{{formatDate(item.endTime, 'yyyy.MM.dd')}}</div>
          <div :class="'c-invalid-icon c-invalid-icon'+item.status"></div>
          <gxxt-button
            v-if="item.status==0"
            class="c-can-use"
            size="small"
            round
            type="primary"
            @click="useCoupon(item)"
          >去使用</gxxt-button>
        </div>
      </li>
    </ul>
    <gxxt-no-data v-if="!isLoadingMore && couponList.records.length==0" text="暂无优惠券～"></gxxt-no-data>
  </div>
</template>

<script>
import { GxxtButton, GxxtNoData } from '@/components'
import dates from '@/utils/dates'
import {
  getAppScrollTop,
  getAppScrollHeight,
  getWindowHeight,
} from '@/utils/common'
export default {
  components: {
    GxxtButton,
    GxxtNoData,
  },
  data() {
    return {
      couponList: {
        records: [],
        pageNum: 1,
        total: 0,
      },
      userInfo: {},
      isLoadingMore: true,
      more: true,
    }
  },
  async mounted() {
    await this.userLoginInfo()
    this.myCouponList()
    this.bindScroll()
  },
  unmounted() {
    this.removeScroll()
  },
  methods: {
    useCoupon(item) {
      if (item.goodsType == 1 && item.couponType == 2) {
        this.$router.push({
          name: 'usage-coupon-goods',
          query: {
            couponId: item.couponId,
          },
        })
      } else {
        this.jumpToHome()
      }
    },
    formatDate(ct, format) {
      return dates.formatDate(ct, format)
    },
    jumpToHome() {
      this.$router.push({ name: 'home' })
    },
    async userLoginInfo() {
      let res = await this.api.login.userLoginInfo()
      if (res && res.code == 200) {
        this.userInfo = res.data
      }
    },
    async myCouponList({ pageNum = 1, more = false } = {}) {
      if (more && !this.more) return
      this.isLoadingMore = true
      let res = await this.api.my.myCouponList({
        pageNum: more ? this.couponList.pageNum + 1 : 1,
      })
      this.isLoadingMore = false
      if (res && res.code == 200) {
        if (more) {
          res.data.records.forEach((item) => {
            this.couponList.records.push(item)
          })
          this.couponList.pageNum = res.data.pageNum
        } else {
          this.couponList = res.data
        }
        if (res.data.totalPage == res.data.pageNum) {
          this.more = false
        }
      }
    },
    bindScroll() {
      document.getElementById('app').addEventListener('scroll', this.scrollFun)
    },
    removeScroll() {
      this.isLoadingMore = false
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollFun)
    },
    scrollFun() {
      let timeAction
      if (this.isLoadingMore) {
        return
      }
      const callback = () => {
        var scrollTop = getAppScrollTop(),
          delta = scrollTop - this.beforeScrollTop
        this.beforeScrollTop = scrollTop
        if (
          delta > 0 &&
          scrollTop + getWindowHeight() + 100 > getAppScrollHeight()
        ) {
          this.loadMoreFn()
        }
      }
      if (timeAction) {
        clearTimeout(timeAction)
      }
      timeAction = setTimeout(callback, 50)
    },
    loadMoreFn() {
      if (this.isLoadingMore) {
        return false
      }
      this.myCouponList({ more: true })
    },
  },
}
</script>

<style lang="less" scoped>
.l-coupons {
  padding: 20px 0 30px;
}
.c-item {
  width: 714px;
  height: 248px;
  background: url('~@/assets/images/my/coupon-item-bg.png') 0 0 no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  display: flex;
}
.c-item__label {
  flex: 240px 0 0;
  font-size: 40px;
  font-weight: 600;
  color: #ff5500;
  line-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-item__info {
  flex: 1 0 0;
  padding: 40px 26px 0;
  text-align: left;
  position: relative;
}
.c-item__title {
  font-size: 30px;
  font-weight: 500;
  color: #222222;
  line-height: 50px;
}
.c-item__rule {
  font-size: 24px;
  color: #888888;
  line-height: 44px;
}
.c-item__date {
  padding-top: 38px;
  font-size: 24px;
  color: #aaaaaa;
  line-height: 24px;
}
.c-can-use {
  position: absolute;
  bottom: 44px;
  right: 34px;
}
.c-item.invalid {
  .c-item__label,
  .c-item__title,
  .c-item__rule,
  .c-item__date {
    color: #cccccc;
  }
  .c-can-use {
    display: none;
  }
  .c-invalid-icon {
    display: block;
  }
}
.c-invalid-icon,
.c-invalid-icon1,
.c-invalid-icon2,
.c-invalid-icon3 {
  width: 115px;
  height: 115px;
  background: url('~@/assets/images/my/coupon-invalid1.png') 0 0 no-repeat;
  background-size: 100% 100%;
  position: absolute;
  bottom: 66px;
  right: 42px;
  display: none;
}
.c-invalid-icon1 {
  background: url('~@/assets/images/my/coupon-invalid1.png') 0 0 no-repeat;
  background-size: 100% 100%;
}
.c-invalid-icon2 {
  background: url('~@/assets/images/my/coupon-invalid2.png') 0 0 no-repeat;
  background-size: 100% 100%;
}
.c-invalid-icon3 {
  background: url('~@/assets/images/my/coupon-invalid3.png') 0 0 no-repeat;
  background-size: 100% 100%;
}
.full-discount {
  .c-item__label {
    flex-direction: column;
    font-size: 44px;
    span {
      font-size: 28px;
      font-weight: 500;
      line-height: 40px;
    }
  }
}
</style>